import { DetailsIcon } from '@/components/tiptap-editor/tiptap-icons/details-icon';
import { forwardRef } from 'react';
import { GenericExtensionButton, type GenericExtensionButtonProps } from '../generic-extension-button';

export const detailsContent = {
    type: 'details',
    content: [
        {
            type: 'detailsSummary',
            content: [
                {
                    type: 'text',
                    text: 'Summary',
                },
            ],
        },
        {
            type: 'detailsContent',
            content: [
                {
                    type: 'paragraph',
                },
            ],
        },
    ],
};

export const DetailsButton = forwardRef<
    HTMLButtonElement,
    Omit<GenericExtensionButtonProps, 'extensionName' | 'extensionType' | 'icon' | 'label' | 'command'>
>((props, ref) => (
    <GenericExtensionButton
        extensionName="details"
        extensionType="node"
        icon={DetailsIcon}
        label="Insert details"
        command={editor => editor.commands.insertContent(detailsContent)}
        ref={ref}
        {...props}
    />
));

DetailsButton.displayName = 'DetailsButton';

export default DetailsButton;
